<form [formGroup]="petForm" (ngSubmit)="submitForm()" class="flex flex-col h-full mt-10">
  <div class="md:flex md:gap-4 md:mb-8">
    <p-floatlabel class="w-full md:w-2/3 mb-8 md:mb-0">
      <input [id]="id + 'name'" pInputText type="text" formControlName="name"
        [pTooltip]="formWatched['children']['name']() | formFieldFeedback" tooltipEvent="focus" tooltipPosition="bottom"
        required class="w-full" />
      <label [for]="id + 'name'">Nome</label>
    </p-floatlabel>
    <div class="mb-8 md:mb-0 w-full">
      <p-float-label>
        <p-datepicker [id]="id + 'data'" appendTo="body" formControlName="birthdate" dateFormat="dd/mm/yy"
          [pTooltip]="formWatched['children']['birthdate']() | formFieldFeedback" [maxDate]="today" tooltipEvent="hover"
          required />
        <label [for]="id + 'data'">Data de Nascimento</label>
      </p-float-label>
    </div>
    <div class="flex justify-center md:mb-0 mb-4">
      <p-selectbutton [id]="id + 'genero'" [options]="genders" optionLabel="name" optionValue="value"
        formControlName="gender" [pTooltip]="formWatched['children']['gender']() | formFieldFeedback"
        tooltipPosition="bottom" tooltipEvent="hover" styleClass="w-full" required />
    </div>
  </div>
  <div class="md:flex md:gap-4 md:mb-8 md:mt-0 mt-4">
    <p-float-label class="w-full mb-8 md:mb-0">
      <p-select [id]="id + 'especie'" formControlName="specie" [options]="species" optionLabel="name"
        optionValue="value" [pTooltip]="formWatched['children']['gender']() | formFieldFeedback"
        tooltipPosition="bottom" tooltipEvent="hover" styleClass="w-full mb-0 md:mb-0" required />
      <label [for]="id + 'especie'">Espécie</label>
    </p-float-label>

    <p-float-label class="w-full mb-8 md:mb-0">
      <input [id]="id + 'raca'" pInputText type="text" formControlName="breed"
        [pTooltip]="formWatched['children']['breed']() | formFieldFeedback" tooltipPosition="bottom"
        tooltipEvent="focus" class="w-full" required />
      <label [for]="id + 'raca'">Raça</label>
    </p-float-label>
  </div>
  <div class="md:flex md:gap-4 md:mb-4">
    <p-float-label class="w-full max-w-full md:max-w-1/2 mb-8 md:mb-0">
      <p-multiselect [id]="id + 'temperamento'" [options]="temperament" formControlName="temperament" optionLabel="name"
        optionValue="value" display="chip" styleClass="w-full"
        [pTooltip]="formWatched['children']['temperament']() | formFieldFeedback" tooltipPosition="bottom"
        tooltipEvent="hover" required />
      <label [for]="id + 'temperamento'">Temperamento</label>
    </p-float-label>

    <p-float-label class="w-full mb-4 md:mb-0">
      <input [id]="id + 'tipoComida'" pInputText type="text" formControlName="foodType"
        [pTooltip]="formWatched['children']['foodType']() | formFieldFeedback" tooltipPosition="bottom"
        tooltipEvent="focus" class="w-full" required />
      <label [for]="id + 'tipoComida'">Tipo de Comida</label>
    </p-float-label>
  </div>
  <div class="mb-4 h-full mt-4 mb-4">
    <p-float-label class="w-full mb-8 md:mb-0">
      <label>Imagens</label>
    </p-float-label>
    @if(enabled()) {
    <div class="border-2-solid border-blue-400 bg-blue-100 px-2 py-4 rounded-lg mt-6">
      <input type="file" [id]="id + 'fileInput'" (change)="onFileChange($event)" accept="image/png, image/jpeg" multiple
        class="sr-only" [disabled]="isLoading() || !enabled()" required />
      <label [for]="id + 'fileInput'"
        class="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 cursor-pointer transition duration-200 ease-in-out">
        Selecionar Arquivos
      </label>
      @if (filesWrapper().length) {}
      <span class="text-sm text-gray-400 ml-4">{{ filesWrapper().length }} arquivo(s) selecionado(s)</span>
    </div>
    }
    <div class="bg-gray-100 mt-4 px-4 py-2 rounded-lg">
      <ul class="list-disc mt-2">
        @for (wrapper of filesWrapper(); track wrapper.previewUrl; let i =
        $index) {
        <li class="flex items-center justify-between list-none">
          <div class="w-full flex items-center">
            <p-image [src]="wrapper.previewUrl" [alt]="`Image to Upload - ${i}`" [preview]="true"
              imageClass="rounded-md h-[50px] w-[50px] object-cover" />
            <span class="ml-4 inline-block max-w-[60%] overflow-hidden text-ellipsis whitespace-nowrap">{{
              wrapper.file.name }}</span>
            <div class="ml-auto">
              <p-button [disabled]="isLoading() || !enabled()" (click)="onRemoveFile(i)" label="Remover"
                icon="pi pi-trash" styleClass="p-button-danger p-button-sm" />
            </div>
          </div>
        </li>

        } @empty {
        <li class="list-none">
          <div
            class="bg-gray-100 mt-4 p-4 rounded-lg font-semibold h-[200px] flex justify-center items-center text-gray-400">
            Nenhum arquivo selecionado
          </div>
        </li>
        }
      </ul>
    </div>
  </div>
  <p-button styleClass="w-full mb-4 font-semibold mt-auto" [loading]="isLoading()"
    [disabled]="isLoading() || !enabled()" type="submit" [label]="initialData() ? 'Atualizar' : 'Cadastrar'" />
</form>